import { render, staticRenderFns } from "./SearchResultsView.vue?vue&type=template&id=0e210531&scoped=true&"
import script from "./SearchResultsView.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsView.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsView.vue?vue&type=style&index=0&id=0e210531&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e210531",
  null
  
)

export default component.exports